import { combineReducers } from "redux";
import { serviceSubscriptionConstants } from "../../actions/services/service-subscription";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: "in default state"
    }
  }
};

function allCompanyServices(state, { type, payload, error }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case serviceSubscriptionConstants.FETCH_SERVICES_SUBSCRIPTION_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case serviceSubscriptionConstants.FETCH_SERVICES_SUBSCRIPTION_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true,
        list: payload.agyoServices
      }
    };
  case serviceSubscriptionConstants.FETCH_SERVICES_SUBSCRIPTION_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: true,
        errorInfo: { code: error.code, message: error.message }
      }
    };
  default:
    return defaultS;
  }
}

function allAccountantServices(state, { type, payload, error }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case serviceSubscriptionConstants.FETCH_ACTIVE_ACCOUNTANT_SERVICE_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case serviceSubscriptionConstants.FETCH_ACTIVE_ACCOUNTANT_SERVICE_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true,
        list: payload.agyoServices
      }
    };
  case serviceSubscriptionConstants.FETCH_ACTIVE_ACCOUNTANT_SERVICE_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: true,
        errorInfo: { code: error.code, message: error.message }
      }
    };
  default:
    return defaultS;
  }
}

function allTsDigitalServices(state, { type, payload, error }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case serviceSubscriptionConstants.ALL_SERVICES_SUBSCRIPTION_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case serviceSubscriptionConstants.ALL_SERVICES_SUBSCRIPTION_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload.agyoServices
    };
  case serviceSubscriptionConstants.ALL_SERVICES_SUBSCRIPTION_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: true,
        errorInfo: { code: error.code, message: error.message }
      }
    };
  default:
    return defaultS;
  }
}

export const servicesAgyo = combineReducers({
  allCompanyServices,
  allAccountantServices,
  allTsDigitalServices
});

export default servicesAgyo;
